import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import 'monaco-editor/esm/vs/editor/standalone/common/themes';

export const insightsQueryExpressionThemes: Record<string, monaco.editor.IStandaloneThemeData> = {
  light: {
    base: 'vs',
    inherit: true,
    rules: [
      { token: 'identifier', foreground: 'd52753' },
      { token: 'identifier.quoted', foreground: '823ff1' },

      { token: 'keyword', foreground: '0098dd' },
      { token: 'operator', foreground: 'a557ff' },

      { token: 'string', foreground: 'c5a332' },
      { token: 'number', foreground: '383a42' },

      { token: 'comment', foreground: 'a0a1a7' },
      { token: 'comment.quote', foreground: 'a0a1a7' },
    ],
    colors: {
      'editor.foreground': '#2e2e2e',
    }
  },
  dark: {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'identifier', foreground: 'e5c07b' },
      { token: 'identifier.quoted', foreground: '60d5c7' },

      { token: 'keyword', foreground: 'c678dd' },
      { token: 'operator', foreground: '61afef' },

      { token: 'string', foreground: '98c379' },
      { token: 'number', foreground: 'd19a66' },

      { token: 'comment', foreground: '7f848e' },
      { token: 'comment.quote', foreground: '7f848e' },
    ],
    colors: {
    }
  },
};

